import React from 'react';

import { Space, Button, Drawer, Input, AutoComplete, Select } from 'antd';

const AddRR = ({ open, onClose, onAdd, forms, formsByConnector, connectors, defaultConnector, onConnectorChange }) => {
    const [form, setForm] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [connector, setConnector] = React.useState(defaultConnector || 'remedy');

    React.useEffect(() => {
        setConnector(defaultConnector || 'remedy');
    }, [defaultConnector, open]);

    const formOptions = connector === 'remedy'
        ? (forms || [])
        : ((formsByConnector || {})[connector] || []);

    const add = () => {
        if (!form) return;
        onAdd({
            form: form,
            ...(connector && connector !== 'remedy' ? { connector: connector } : {}),
            description: description,
            query: '',
            fields: {},
            constants: {}
        });
        setForm('');
        setDescription('');
    };

    return (
        <Drawer
            title="Add related record"
            width={520}
            onClose={onClose}
            open={open}
            bodyStyle={{
                paddingBottom: 80,
            }}
            extra={
                <Space>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button onClick={add} type="primary" disabled={!form}>
                        Add
                    </Button>
                </Space>
            }
        >
            {connectors && connectors.length > 0 && (
                <>
                    <div style={{ marginBottom: 8 }}>Source</div>
                    <Select
                        value={connector}
                        onChange={(c) => {
                            setConnector(c);
                            if (onConnectorChange) onConnectorChange(c);
                        }}
                        style={{ width: '100%', marginBottom: 16 }}
                        options={connectors.map((c) => ({ value: c.name, label: c.displayName || c.name }))}
                        aria-label="Source system connector"
                    />
                </>
            )}
            <div style={{ marginBottom: 8 }}>Form</div>
            <AutoComplete
                value={form}
                options={formOptions.map((f) => ({ value: f }))}
                filterOption={(input, o) => o.value.toLowerCase().includes(input.toLowerCase())}
                onChange={setForm}
                style={{ width: '100%', marginBottom: 16 }}
                placeholder={connector === 'remedy' ? 'e.g. HPD:Help Desk' : 'Record definition / collection'}
            />
            <div style={{ marginBottom: 8 }}>Description</div>
            <Input value={description} onChange={(e) => setDescription(e.target.value)} placeholder="e.g. Customer" />
        </Drawer>
    );
};

export default AddRR;
